var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !!_vm.previousQuestionId
    ? _c(
        "div",
        {
          staticClass: "audio-icon",
          style: {
            borderColor: _vm.iconColor,
            backgroundColor: _vm.iconBackgroundColor,
          },
          on: {
            click: function ($event) {
              return _vm.goToPreviousQuestion()
            },
          },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  transform: "translate(3, 3)",
                  d: "M6 13.7979V0.797852M6 0.797852L1 5.79785M6 0.797852L11 5.79785",
                  stroke: _vm.iconColor,
                },
              }),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }